module.exports = __webpack_public_path__ + "static/media/insta2.663d44fb.jpg";